import { getStepFieldSettings } from '../../../utils/step-field';
import { getStepValidator } from './get-step-validator';
export function useFormFieldsData({ steps = [] }) {
    const { fieldsValidators, fieldsMap, initialValues } = steps.reduce((acc, step) => {
        const fieldSettings = getStepFieldSettings(step);
        if (fieldSettings && fieldSettings.name) {
            const { name, value } = fieldSettings;
            acc.fieldsMap[name] = { ...fieldSettings, quizStepType: step.type };
            if (step.type === 'checkbox-group') {
                acc.initialValues[name] = [];
            }
            else if (step.type === 'rating') {
                acc.initialValues[name] = { rating: value || '' };
            }
            else {
                acc.initialValues[name] = value || '';
            }
            acc.fieldsValidators[name] = getStepValidator(step);
        }
        return acc;
    }, {
        initialValues: {},
        fieldsValidators: {},
        fieldsMap: {},
    });
    return { fieldsValidators, fieldsMap, initialValues };
}
//# sourceMappingURL=use-form-fields-data.js.map